module.exports = __webpack_public_path__ + "files/26e2a94f5a865ed7fa9f9992d1b822ff.png";